export default __webpack_public_path__ + "static/media/economic.2d5944de.svg";